import React from "react";
import styles from "./language.module.css";

export default function LanguageModal({ flags, changeLang }) {

  return (
    <div className={`${styles["language-modal"]}`}>
      <div
        className={styles["language-line"]}
        onClick={(e) => changeLang("arm", e)}
      >
        <img src="/armenian.webp" alt={"am"} /> Am
      </div>
      <div className={styles["language-line"]} onClick={(e) => changeLang("ru", e)}>
        <img src={flags["ru"]} alt={"ru"} /> Ru
      </div>
      <div
        className={styles["language-line"]}
        onClick={(e) => changeLang("eng", e)}
      >
        <img src={flags["eng"]} alt={"eng"} /> Eng
      </div>
    </div>
  );
}
